import { closeSession, newSession } from "@entities/session";

const CHANNEL_NAME = "kex-session-sync";

type SyncMessage = { accessToken: string; type: "new" } | { type: "close" };

const channel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(CHANNEL_NAME)
    : null;

if (channel) {
  let isApplyingRemote = false;

  newSession.watch(({ accessToken }) => {
    if (isApplyingRemote) {
      return;
    }
    channel.postMessage({ accessToken, type: "new" } satisfies SyncMessage);
  });

  closeSession.watch(() => {
    if (isApplyingRemote) {
      return;
    }
    channel.postMessage({ type: "close" } satisfies SyncMessage);
  });

  channel.onmessage = (event: MessageEvent<SyncMessage>) => {
    const message = event.data;

    isApplyingRemote = true;
    try {
      if (message.type === "new") {
        newSession({ accessToken: message.accessToken });
      } else {
        closeSession();
      }
    } finally {
      isApplyingRemote = false;
    }
  };
}
